import React, { createContext, useContext, useState } from 'react';
import { Tournament } from '../models/Tournament';

interface SelectedTournamentContextType {
  selectedTournament: Tournament | null;
  setSelectedTournament: (tournament: Tournament | null) => void;
  clearSelectedTournament: () => void;
}

const SelectedTournamentContext = createContext<SelectedTournamentContextType | undefined>(undefined);

export const SelectedTournamentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedTournament, setSelectedTournamentState] = useState<Tournament | null>(null);

  const setSelectedTournament = (tournament: Tournament | null) => {
    setSelectedTournamentState(tournament);
  };

  const clearSelectedTournament = () => {
    setSelectedTournamentState(null);
  };

  return (
    <SelectedTournamentContext.Provider value={{ selectedTournament, setSelectedTournament, clearSelectedTournament }}>
      {children}
    </SelectedTournamentContext.Provider>
  );
};

export const useSelectedTournament = (): SelectedTournamentContextType => {
  const context = useContext(SelectedTournamentContext);
  if (!context) {
    throw new Error('useSelectedTournament must be used within a SelectedTournamentProvider');
  }
  return context;
};
